import type { FaireProductEntity } from "../../entity_types/product";

export const p_vrum47fjdd: FaireProductEntity = {
  token: "p_vrum47fjdd",
  type: "product",
  name: "Southwest Assorted Semi-precious Stone Beaded Bracelets",
  brandToken: "b_46yqo0x0y0",
  brandName: "El Paso Saddleblanket",
  imageUrl:
    "https://cdn.faire.com/fastly/69349537a9f54eecc9840e9f9b7893c274e79f312945a1f24a8840f994e5227e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9a7d50657a9e85157fbda41980c0af4d4e88253d6aa2d58fe0615262501e8157.jpeg",
  ],
  priceDollars: 6.58,
  description:
    "\nColorful Assorted Southwest Beaded Bracelets. \n\nSold in an assortment of colors.\n\nIncludes stones such as: Amethyst, Black Agate, Golden Sheen, Jasper, Red Agate, Rose Quartz, Tiger's Eye, Turquoise, Unakite & White Agate\n\n\n\n\nTo see our Handcrafted Beaded Anklets CLICK HERE.\n\nTo see our Handcrafted Beaded Anklets CLICK HERE.\n\nFor more Jewelry CLICK HERE\n\nFor Apparel CLICK HERE\n\nFor Shawls and Scarves Click Here\n",
  tags: [],
  msrpDollars: 11.52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:37.441Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
